import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private queryParams: any = {
    beginDate: '1999-12-25',
    endDate: '9999-12-25',
    healthFacilityId: -5,
  };
  api_url = environment.api_endpoint;
  tobaccoDashboardUrl: string = this.api_url + 'tobacco-cessation-dashboard/';
  savedHealthFacilityId : any;
  constructor(private http: HttpClient) {}

  setQueryParams(params: any): void {
    // set empty query params if no start date and end date is provided
    if (!params.startDate && !params.lastDate) {
      if (!params.healthFacilityId) {
        this.queryParams = {};
        return;
      } else {
        this.queryParams = {};
        this.queryParams.healthFacilityId = params.healthFacilityId;
        this.savedHealthFacilityId = params.healthFacilityId;
        return;
      }
    }
    this.queryParams.beginDate = params.startDate;
    this.queryParams.endDate = params.lastDate;
    if (params.healthFacilityId !== -5) {
      this.queryParams.healthFacilityId = params.healthFacilityId;
    } else {
      delete this.queryParams.healthFacilityId;
    }
  }

  getLoggedInHospitalName(): string {
    return JSON.parse(localStorage.getItem('userInfo') || '{}')?.hospitalName;
  }
  getLoggedInHospitalId(): number {
    return +(JSON.parse(localStorage.getItem('healthFacilityId') || '') || '');
  }

  // Dashboard API's-------------------------------------------

  // Hypertension API's------
  getHypertensionPercentage() {
    return this.http.get(this.api_url + 'dashboard/hypertension-percentage', {
      params: this.queryParams,
    });
  }
  getNewHypertensionPatients() {
    return this.http.get(this.api_url + 'dashboard/new-hypertension-patients', {
      params: this.queryParams,
    });
  }
  // Hypertension API's------

  getHighCvdPercentage() {
    return this.http.get(this.api_url + 'dashboard/high-cvd-percentage', {
      params: this.queryParams,
    });
  }
  getNewCVD() {
    return this.http.get(
      this.api_url + 'dashboard/new-heart-disease-patients',
      {
        params: this.queryParams,
      }
    );
  }

  getDiabeticRetionopathy() {
    return this.http.get(this.api_url + 'dashboard/diabetic-retinopathy', {
      params: this.queryParams,
    });
  }
  getDiabeticNephropathy() {
    return this.http.get(this.api_url + 'dashboard/diabetic-nephropathy', {
      params: this.queryParams,
    });
  }

  // Diabetic AMP API's------
  getDiabeticAmputation() {
    return this.http.get(this.api_url + 'dashboard/diabetic-amputations', {
      params: this.queryParams,
    });
  }
  getDiabeticLowerLimbAmputation() {
    return this.http.get(
      this.api_url + 'dashboard/diabetic-lower-limb-amputation',
      {
        params: this.queryParams,
      }
    );
  }
  // Diabetic AMP API's------

  // Diabetes API's------
  getDiabetesPercentage() {
    return this.http.get(this.api_url + 'dashboard/diabetes-percentage', {
      params: this.queryParams,
    });
  }
  getNewDiabeticPatients() {
    return this.http.get(this.api_url + 'dashboard/new-diabetic-patients', {
      params: this.queryParams,
    });
  }
  // Diabetes API's------

  // BMI API's------
  getBmiPercentage() {
    return this.http.get(this.api_url + 'dashboard/bmi-percentage', {
      params: this.queryParams,
    });
  }
  getNewBmiPatients() {
    return this.http.get(this.api_url + 'dashboard/new-bmi-patients', {
      params: this.queryParams,
    });
  }

  // CVD Table API's------
  getCVDAgeRange() {
    return this.http.get(this.api_url + 'dashboard/cvd-age-range', {
      params: this.queryParams,
    });
  }

  // Covid cases API's------
  getCovidPositiveCases() {
    return this.http.get(this.api_url + 'dashboard/covid-positive-cases', {
      params: this.queryParams,
    });
  }

  getNCDVisit() {
    return this.http.get(this.api_url + 'dashboard/ncd-visit-fortyabove', {
      params: this.queryParams,
    });
  }
  getNcdOutpatientVisit(year: string) {
    return this.http.get(this.api_url + 'dashboard/outpatient-visits-ncd', {
      params: { ...this.queryParams, year },
    });
  }

  // Active Smokers API's----
  getActiveSmokers() {
    return this.http.get(this.api_url + 'dashboard/active-smokers', {
      params: this.queryParams,
    });
  }

  getAllHealthFacilities() {
    return this.http.get(this.api_url + 'dashboard/health-facilities/all');
  }

  getTobaccoDashboardDataFor(path: any): Observable<any> {
    return this.http.get(this.tobaccoDashboardUrl + path, {
      params:this.queryParams,
    });
}
getPatientSummary(): Observable<any> {
  return this.http.get(this.api_url + 'dashboard/patients-summary', {
    params: this.queryParams,
  });
}

getHypertension(): Observable<any> {
  return this.http.get(
    this.api_url + 'dashboard/old-and-new-hypertension-percentage',
    {
      params: this.queryParams,
    }
  );
}

getCvdRisk(): Observable<any> {
  return this.http.get(
    this.api_url + 'dashboard/old-and-new-high-cvd-percentage',
    {
      params: this.queryParams,
    }
  );
}

getDiabetic(): Observable<any> {
  return this.http.get(
    this.api_url + 'dashboard/old-and-new-daibetic-percentage',
    {
      params: this.queryParams,
    }
  );
}

getBmi(): Observable<any> {
  return this.http.get(this.api_url + 'dashboard/old-and-new-bmi-percentage', {
    params: this.queryParams,
  });
}

}


